module.exports = __webpack_public_path__ + "img/8-1_03.0d310b04.jpg";